define(function(require) {
    'use strict';
    var AppConfig = require('config/application');
    var Model = require('models/mail_domain');

    return Backbone.Collection.extend({
        url: AppConfig.host + '/rest/domains',
        model: Model,
        parse: function(response, options) {
            if(response.status == 1) {
                return response.result
            }
        }
    });
});